package org.ttt.autogenesis.config

import org.w3c.xhr.XMLHttpRequest

actual object ConfigSource {
    actual fun property(filename: String, key: String): String {
        readProperty(filename, key)?.let { return it }
        error("$filename missing key '$key'")
    }

    actual fun propertyOrEmpty(filename: String, key: String): String =
        readProperty(filename, key) ?: ""

    /**
     * Reads the trimmed value of [key] from the JS-bundled [filename] copy.
     * Returns null when the file is missing, the key is absent, or the value
     * is blank. See [property] for the strict contract and [propertyOrEmpty]
     * for the lenient contract.
     */
    private fun readProperty(filename: String, key: String): String? {
        // Sync XHR — only safe at app startup, NOT inside a Promise chain.
        // gradle-wired copy task in kvisionApp/build.gradle.kts places the
        // *.local.properties files into src/jsMain/resources/ before bundling.
        val req = XMLHttpRequest()
        req.open("GET", filename, false)
        req.send()
        if (req.status != 200.toShort()) return null
        val line = req.responseText.lineSequence().firstOrNull { it.startsWith("$key=") }
            ?: return null
        val value = line.substringAfter("=").trim()
        return value.takeIf { it.isNotEmpty() }
    }
}